import React from 'react'
import './footer.scss'

const Footer = () => {
    return <p className='footer'>{'\u00A9'} 2020 Countlories All Rights Reserved</p>;
}

export default Footer